
import VectorSource from 'ol/source/Vector';

import DrawGeometry from './DrawGeomerty';

function createInteractionDrawPoint(options) {
    let source = new VectorSource({});

    let draw = new DrawGeometry({
        source: source,
        type: 'Point'
    });

    draw.set('mapToolId', 'DrawPoint');
    draw.setActive(false);

    draw.on('drawend', (e) => {
        if (options.onMapToolExecute) {
            options.onMapToolExecute(
                draw.get('mapToolId'),
                {
                    feature: e.feature
                }
            );
        }
    });

    return draw;
}

export default createInteractionDrawPoint;
